<template>
  <div class="page" style="margin-top: 40px;">
    <Button class="choice-btn" @click="onShowDomainList">从我的域名列表选择域名</Button>
    <!-- 过户域名 -->
    <Form style="margin-top: 40px">
      <FormItem class="cc-form-item" :label="'过户域名' + dnNumber" required>
        <Input
          class="bj-input-26262A"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 500 }"
          v-model="form.domain"
          @on-keyup="getDNNumber"
          @on-blur="getAvailableDN"
          placeholder="每行一个域名，最多500个"
          style="width: 500px"
        ></Input>
      </FormItem>
      <FormItem class="cc-form-item" label="选择模板" required>
        <div class="bj-rows content-start">
          <div class="item" style="margin-right: 100px">
            <Button type="primary" class="bj-search-btn-F85A36" @click="showCheckedTemplate">{{
              !templateInfo.id ? "点击选择" : templateInfo.name
            }}</Button>
          </div>
        </div>
      </FormItem>
      <FormItem class="cc-form-item" label="60天内禁止转移注册商锁定" required>
        <div class="bj-rows content-start" style="line-height: 32px">
          <RadioGroup v-model="form.isLock" style="color: #fff">
            <Radio class="bj-color-F85A36" :label="0"> 不设置</Radio>
            <Radio class="bj-color-F85A36" :label="1"> 设置</Radio>
          </RadioGroup>
          <div style="color: #F85A36">
            (域名若设置60天内禁止转移注册商锁定，模板过户成功后60天你才可以转出)
          </div>
        </div>
      </FormItem>
      <div class="bj-rows">
        <Checkbox class="bj-color-F85A36" v-model="single">
          我已同意并阅读</Checkbox
        >
        <span style="color: #f85a36; cursor: pointer"  @click.prevent="ruleModelShow = true"
        >《{{ ruleTitle }}》</span
        >
      </div>
      <div class="bj-rows" style="margin-top: 10px">
        <Button
        class="bj-w120 bj-h45 bj-confirm-btn"
        :loading="loading"
        type="primary"
        @click="onConfirm"
        >确认提交</Button>
      </div>
    </Form>
    <!-- 选择域名 -->
    <domainListModal
      :show.sync="domainListModalVisibility"
      :checkedDomain="checkedDomain"
      @onChecked="onChecked"
    ></domainListModal>
    <!-- 选择模板 -->
    <templateListModal
      :show.sync="templateListModalVisibility"
      :id="templateInfo.id"
      @onChecked="checkedTemplate"
    ></templateListModal>
    <!-- 转入结果 -->
    <transferListModal
      :show.sync="transferistModalVisibility"
      :data="resultList"
    ></transferListModal>
    <rule-modal
        :show.sync="ruleModelShow"
        :content="ruleContent"
        :title="ruleTitle"
    ></rule-modal>
  </div>
</template>
<script>
import domainListModal from "components/domain/domainListModal.vue";
import templateListModal from "components/template/templateListModal.vue";
import transferListModal from "components/template/transferListModal.vue";
import { debounce, trimStr } from "utils/index";
import { templatesTransfer } from "api/domain.js";
import { mapMutations, mapState } from "vuex";
import ruleModal from "components/ruleModal.vue";
import templateRules from "assets/rule/templateRules";

export default {
  name: "templateTransfer",
  components: {
    domainListModal,
    templateListModal,
    transferListModal,
    ruleModal,
  },
  data() {
    return {
      loading: false,
      domainListModalVisibility: false,
      templateListModalVisibility: false,
      templateInfo: {},
      checkedDomain: [],
      form: {
        domain: "",
        isLock: 0,
      },
      dnNumber: 0,
      transferistModalVisibility: false,
      resultList: [],

      single: false,
      ruleModelShow: false,
      ruleContent: "",
      ruleTitle: "",
    };
  },
  computed: {
    ...mapState(["routeParamsList"]),
  },
  created() {
    this.ruleContent = templateRules.content;
    this.ruleTitle = templateRules.title;
    if (this.routeParamsList.length > 0) {
      this.checkedDomain = this.routeParamsList;
      const domainStr = this.routeParamsList.join("\n");
      this.form.domain = domainStr;
      this.dnNumber = this.routeParamsList.length;
    }
  },
  beforeDestroy() {
    // 传递参数
    this.MTU_ROUTE_PARAMS_LIST([]);
  },
  methods: {
    ...mapMutations(["MTU_ROUTE_PARAMS_LIST"]),
    onShowDomainList() {
      this.domainListModalVisibility = true;
    },
    // 选中域名
    onChecked(val) {
      this.checkedDomain = val;
      const domainStr = val.join("\n");
      this.form.domain = domainStr;
      this.dnNumber = val.length;
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    // 函数防抖获取输入框中的域名
    getDNNumber: debounce(function () {
      const temp = this.form.domain.split("\n");
      this.dnNumber = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN() {
      const temp = this.form.domain.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet = new Set(dnList);
      this.checkedDomain = [...this.dnSet];
      this.form.domain = [...this.dnSet].join("\n");
      this.dnNumber = this.dnSet.size;
    },
    async onConfirm() {
      try {
        if (!this.single) {
          this.$Message.warning("请输入阅读协议后并同意!");
          return false;
        }
        let domains = this.form.domain.split("\n").filter((item) => {
          return !item.match(/^[ ]*$/);
        });
        if (domains.length === 0) {
          this.$Message.warning("请输入域名！");
          return false;
        }
        if (!this.templateInfo.id) {
          this.$Message.warning("请选择模板！");
          return false;
        }
        this.loading = true;
        let params = {
          ymList: domains,
          isLock: this.form.isLock,
          templateId: this.templateInfo.id,
        };
        const { code, data } = await templatesTransfer(params);
        if (code === 200) {
          if (data.length === 0) {
            // 无逐域名结果时按整体成功处理（兜底）
            this.pushSuccess();
            this.$Message.success("操作成功!");
          } else {
            // 全部为过户成功（状态2）时，清空表单
            const allSuccess = data.every((item) => item.status == 2);
            if (allSuccess) {
              this.pushSuccess();
            }
            // 弹窗显示逐域名结果（成功提示/失败原因）
            this.resultList = data;
            this.transferistModalVisibility = true;
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 过户成功处理：清空表单
    pushSuccess() {
      this.form.domain = "";
      this.form.isLock = 0;
      this.dnNumber = 0;
      this.dnSet = new Set();
      this.templateInfo = {};
      this.checkedDomain = [];
    },
  },
};
</script>

<style lang="less" scoped>
.choice-btn{
  color: #F85A36;
  background-color: #252629;
  border-color: #fff;
  height: 45px;
  line-height: 45px;
}

::v-deep .ivu-form-item-label{
  min-width: 160px;
  text-align: right;
  color: #fff;
}
</style>
